import { render, staticRenderFns } from "./OrderProductPiecesList.vue?vue&type=template&id=9db9d6e0&"
import script from "./OrderProductPiecesList.vue?vue&type=script&lang=js&"
export * from "./OrderProductPiecesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports